/**
 * Created by wkuzia on 15.01.19.
 */
export class User {
    private _email: string;
    private _password: string;
    private _isAdmin: boolean;
    private _isClient: boolean;
    private _firstName: string;
    private _lastName: string;
    private _workPhone: string;
    private _preferredFormOfContact: string;
    private _area: string;
    private _workExperience: number;
    private _agreement: boolean;
    private _active: boolean;
    private _position : string;


    get position(): string {
        return this._position;
    }

    set position(value: string) {
        this._position = value;
    }

    get email(): string {
        return this._email;
    }

    set email(value: string) {
        this._email = value;
    }

    get password(): string {
        return this._password;
    }

    set password(value: string) {
        this._password = value;
    }

    get isAdmin(): boolean {
        return this._isAdmin;
    }

    set isAdmin(value: boolean) {
        this._isAdmin = value;
    }

    get firstName(): string {
        return this._firstName;
    }

    set firstName(value: string) {
        this._firstName = value;
    }

    get lastName(): string {
        return this._lastName;
    }

    set lastName(value: string) {
        this._lastName = value;
    }

    get workPhone(): string {
        return this._workPhone;
    }

    set workPhone(value: string) {
        this._workPhone = value;
    }

    get preferredFormOfContact(): string {
        return this._preferredFormOfContact;
    }

    set preferredFormOfContact(value: string) {
        this._preferredFormOfContact = value;
    }

    get area(): string {
        return this._area;
    }

    set area(value: string) {
        this._area = value;
    }

    get workExperience(): number {
        return this._workExperience;
    }

    set workExperience(value: number) {
        this._workExperience = value;
    }

    get agreement(): boolean {
        return this._agreement;
    }

    set agreement(value: boolean) {
        this._agreement = value;
    }

    get active(): boolean {
        return this._active;
    }

    set active(value: boolean) {
        this._active = value;
    }

    get isClient() : boolean {
        return this._isClient
    }

    set isClient(value: boolean) {
        this._isClient = value;
    }


    constructor(firstName: string, lastName: string, email: string) {
        this._email = email;
        this._firstName = firstName;
        this._lastName = lastName;
    }
}